import { Vue } from 'vue-property-decorator'

export const campaignExecutionStatus = () => {
  return {
    QUEUED: { key: 50600001, label: Vue.prototype.$gettext('CAMPAIGN_EXECUTION_STATUS.50600001') },
    PROCESSING: { key: 50600002, label: Vue.prototype.$gettext('CAMPAIGN_EXECUTION_STATUS.50600002') },
    COMPLETED: { key: 50600003, label: Vue.prototype.$gettext('CAMPAIGN_EXECUTION_STATUS.50600003') },
    FAILED: { key: 50600004, label: Vue.prototype.$gettext('CAMPAIGN_EXECUTION_STATUS.50600004') },
    CANCELLED: { key: 50600005, label: Vue.prototype.$gettext('CAMPAIGN_EXECUTION_STATUS.50600005') }
  }
}
